import './App.css'
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'
import { ScrollToTop, useIsMobile, UniversalScaler } from 'helpers'
import { QueryClient, QueryClientProvider } from 'react-query'
import { useState } from 'react'

import {
  Home,
  Session,
  ContactList,
} from 'pages'

import {
  MobileHome,
  MobileSession,
} from 'mobile-pages'

const App = () => {
  const isMobile = useIsMobile()

  // DESKTOP ROUTES
  const desktopRoutes = () => (
    <>
      <Route path='/' element={<Home />} />
      <Route path='/session-discussion' element={<Session />} />
      <Route path='/contacts' element={<ContactList />} />
    </>
  )

  // MOBILE ROUTES
  const mobileRoutes = () => (
    <>
      <Route path='/' element={<MobileHome />} />
      <Route path='/session-discussion' element={<MobileSession />} />
    </>
  )

  // REACT QUERY
  const [queryClient] = useState(() => new QueryClient())

  // ROUTE CONTENT
  const routeContent = (
    <Routes>
      {isMobile ? mobileRoutes() : desktopRoutes()}
    </Routes>
  )

  return (
    <Router>
      <QueryClientProvider client={queryClient}>
        <ScrollToTop />
        {/* <Routes> */}
          {
            isMobile
            ? routeContent
            : <UniversalScaler>{routeContent}</UniversalScaler>
            // : routeContent
          }
        {/* </Routes> */}
      </QueryClientProvider>
    </Router>
  );
}

export default App;
